const COMMENTS = [
  {
    name: '追番小白',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20avatar%20portrait%20of%20a%20young%20girl%20with%20pink%20hair%2C%20simple%20clean%20background%2C%20soft%20warm%20lighting%2C%20chibi%20style%2C%20minimalist%20design&width=120&height=120&seq=avatar-01&orientation=squarish',
    time: '3小时前',
    content: '终于找到能稳定看动漫的地方了！画质清晰不卡顿，追番体验感真的很好。',
    likes: 1286,
  },
  {
    name: '二次元老司机',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20avatar%20portrait%20of%20a%20cool%20boy%20with%20dark%20hair%2C%20simple%20clean%20background%2C%20soft%20warm%20lighting%2C%20chibi%20style%2C%20minimalist%20design&width=120&height=120&seq=avatar-02&orientation=squarish',
    time: '5小时前',
    content: '完结动漫专区太良心了，一口气补完了《钢炼》和《石头门》，经典永不过时。',
    likes: 953,
  },
  {
    name: '动漫迷妹',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20avatar%20portrait%20of%20a%20cute%20girl%20with%20blue%20hair%2C%20simple%20clean%20background%2C%20soft%20warm%20lighting%2C%20chibi%20style%2C%20minimalist%20design&width=120&height=120&seq=avatar-03&orientation=squarish',
    time: '8小时前',
    content: '更新超快！每周新番第一时间就能看，分类也很全，国漫日漫都有。',
    likes: 721,
  },
  {
    name: '深夜追番人',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20avatar%20portrait%20of%20a%20sleepy%20looking%20character%20with%20glasses%2C%20simple%20clean%20background%2C%20soft%20warm%20lighting%2C%20chibi%20style%2C%20minimalist%20design&width=120&height=120&seq=avatar-04&orientation=squarish',
    time: '12小时前',
    content: '弹幕氛围很好，不像某些平台全是吵架。特别是热血番的弹幕超有意思。',
    likes: 618,
  },
  {
    name: '樱花飘落时',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20avatar%20portrait%20of%20a%20gentle%20looking%20girl%20with%20long%20brown%20hair%2C%20simple%20clean%20background%2C%20soft%20warm%20lighting%2C%20chibi%20style%2C%20minimalist%20design&width=120&height=120&seq=avatar-05&orientation=squarish',
    time: '1天前',
    content: '手机端也适配得很好，通勤路上也能追番，离线缓存功能太实用了！',
    likes: 504,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">漫友热评</h2>
          <p className="text-sm text-foreground-500">来自追番小伙伴的真实声音</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {COMMENTS.map((comment) => (
            <div
              key={comment.name}
              className="p-5 bg-background-50 border border-background-200/70 rounded-xl"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-100 flex-shrink-0">
                  <img src={comment.avatar} alt={comment.name} className="w-full h-full object-cover" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-medium text-foreground-900">{comment.name}</div>
                  <div className="text-xs text-foreground-400">{comment.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">{comment.content}</p>
              <div className="flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-heart-line text-accent-500"></i>
                <span>{comment.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}